// extracted by mini-css-extract-plugin
export default {"friendsContainer":"friendsLine_friendsContainer__bc-Wz","item":"friendsLine_item__CF4IY"};